import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';

import { OpenSwal } from '../../Utils';

import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined';
import { url_get_asssignment_summary } from '../../RoutesMap';
import { apiWithAuth } from '../../Services/Axios/axios';


export default function AssignmentViewBilling({ assign_id, AssignmentDetailsAry, AssignmentHeadingPageNameSet, URLThirdSegmentName }) {

    const navigate = useNavigate();
    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
  

    const [viewBillingAssignmentDetailsAry, viewBillingAssignmentDetailsArySet] = useState({});


    useEffect(() => {
        let payload = new FormData();
        payload.append('assignid', assign_id);
        apiWithAuth.post(url_get_asssignment_summary, payload, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
            if (response.data.status) {
                AssignmentHeadingPageNameSet('Billing Summary');
                viewBillingAssignmentDetailsArySet(response.data.data);
            } else if (response.data.status === false && response.data.message === "Token Expired") OpenSwal('Token_error', navigate);
            else OpenSwal('Axios_error', response.data.message);
        }).catch(response => OpenSwal('Axios_error', response.message));
    }, []);




    return (

        <Box>
            <Box sx={{ mt: 2, mb: 10 }}>



                <Box>
                    <Box>

                        <Typography sx={{ typography: { xs: 'subtitle1', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={{ fontWeight: 'bold', textDecoration: 'underline', textDecorationThickness: '3px', textUnderlineOffset: '6px' }} >Billing Summary for {AssignmentDetailsAry.assign_orderid}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>


                        <TableContainer sx={{ borderTop: 2, borderColor: '#a2a2a2de' }}  >
                            <Table size="small" >
                                <TableHead>
                                    <TableRow sx={{ borderBottom: 2, borderColor: '#a2a2a2de' }}>
                                        <TableCell sx={{ paddingLeft: '2px' }} ><Typography sx={{ typography: { xs: 'subtitle2', sm: 'subtitle1' } }} style={{ fontWeight: 'bold' }} >Description</Typography></TableCell>
                                        <TableCell sx={{ paddingRight: '2px' }} ><Typography sx={{ typography: { xs: 'subtitle2', sm: 'subtitle1' } }} style={{ fontWeight: 'bold' }} textAlign='right'>Amount in USD</Typography></TableCell>



                                    </TableRow>
                                </TableHead>
                                <TableBody  >

                                    <TableRow   >
                                        <TableCell sx={{ paddingLeft: '2px' }} > <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }}>Interpreted Duration</Typography> </TableCell>
                                        <TableCell sx={{ paddingRight: '2px' }}>
                                            <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }} textAlign='right'>{viewBillingAssignmentDetailsAry.assign_duration_mins} Mins</Typography>
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell sx={{ paddingLeft: '2px' }} > <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }}>Base Duration</Typography> </TableCell>
                                        <TableCell sx={{ paddingRight: '2px' }}>
                                            <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }} textAlign='right'>{viewBillingAssignmentDetailsAry.assign_minimum_duration_mins} Mins</Typography>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow   >
                                        <TableCell sx={{ paddingLeft: '2px' }} > <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }}>Base Duration Amount</Typography> </TableCell>
                                        <TableCell sx={{ paddingRight: '2px' }}>
                                            <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }} textAlign='right'>$ {viewBillingAssignmentDetailsAry.assign_duration_amount}</Typography>
                                        </TableCell>
                                    </TableRow>

                                    {viewBillingAssignmentDetailsAry.assign_int_extra_mins !== "" && viewBillingAssignmentDetailsAry.assign_int_extra_mins > 0 && <TableRow   >
                                        <TableCell sx={{ paddingLeft: '2px' }} >
                                            <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }}>Extended Duration</Typography>

                                        </TableCell>
                                        <TableCell sx={{ paddingRight: '2px' }}>
                                            <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }} textAlign='right'>{viewBillingAssignmentDetailsAry.assign_int_extra_mins} Mins</Typography>
                                        </TableCell>
                                    </TableRow>}
                                    {viewBillingAssignmentDetailsAry.assign_int_extra_mins !== "" && viewBillingAssignmentDetailsAry.assign_int_extra_mins > 0 && <TableRow   >
                                        <TableCell sx={{ paddingLeft: '2px' }} >
                                            <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }}>Extended Duration Amount</Typography>

                                        </TableCell>
                                        <TableCell sx={{ paddingRight: '2px' }}>
                                            <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }} textAlign='right'>$ {viewBillingAssignmentDetailsAry.assign_int_extra_dur_amt}</Typography>
                                        </TableCell>
                                    </TableRow>}

                                    {viewBillingAssignmentDetailsAry.assign_travel_amount_int !== '' && <TableRow   >
                                        <TableCell sx={{ paddingLeft: '2px' }} >
                                            <Box><Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }}>Travel Allowance</Typography></Box>
                                        </TableCell>
                                        <TableCell sx={{ paddingRight: '2px' }}>
                                            <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }} textAlign='right'>$ {viewBillingAssignmentDetailsAry.assign_travel_amount_int}</Typography>
                                        </TableCell>
                                    </TableRow>}
                                    {viewBillingAssignmentDetailsAry.assign_mileage_amount_int !== '' && <TableRow>
                                        <TableCell sx={{ paddingLeft: '2px' }}  >
                                            <Box><Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }} >Mileage Allowance</Typography></Box>
                                        </TableCell>
                                        <TableCell sx={{ paddingRight: '2px' }}>
                                            <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }} textAlign='right'>$ {viewBillingAssignmentDetailsAry.assign_mileage_amount_int}</Typography>
                                        </TableCell>
                                    </TableRow>}


                                    {viewBillingAssignmentDetailsAry.assign_parking_cost !== "" && viewBillingAssignmentDetailsAry.assign_parking_cost > 0 && <TableRow>
                                        <TableCell sx={{ paddingLeft: '2px' }}  >
                                            <Box><Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }} >Parking Cost </Typography></Box>
                                        </TableCell>
                                        <TableCell sx={{ paddingRight: '2px' }}>
                                            <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }} textAlign='right'>$ {viewBillingAssignmentDetailsAry.assign_parking_cost}</Typography>
                                        </TableCell>
                                    </TableRow>}

                                    {viewBillingAssignmentDetailsAry.assign_shipping_cost !== "" && viewBillingAssignmentDetailsAry.assign_shipping_cost > 0 && <TableRow >
                                        <TableCell sx={{ paddingLeft: '2px' }}  >
                                            <Box><Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }} >Shipping Cost </Typography></Box>

                                        </TableCell>
                                        <TableCell sx={{ paddingRight: '2px' }}>
                                            <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }} textAlign='right'>$ {viewBillingAssignmentDetailsAry.assign_shipping_cost}</Typography>
                                        </TableCell>
                                    </TableRow>}
                                    {viewBillingAssignmentDetailsAry.assign_other_cost !== "" && viewBillingAssignmentDetailsAry.assign_other_cost > 0 && <TableRow>
                                        <TableCell sx={{ paddingLeft: '2px' }}  >
                                            <Box><Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }} >Other Cost </Typography></Box>

                                        </TableCell>
                                        <TableCell sx={{ paddingRight: '2px' }}>
                                            <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }} textAlign='right'>$ {viewBillingAssignmentDetailsAry.assign_other_cost}</Typography>
                                        </TableCell>
                                    </TableRow>}



                                    <TableRow sx={{ borderBottom: 2, borderTop: 2, borderColor: '#a2a2a2de' }}  >
                                        <TableCell sx={{ paddingLeft: '2px' }} >

                                            <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }} style={{ fontWeight: 'bold' }}>Total Billable Amount</Typography>

                                        </TableCell>
                                        <TableCell sx={{ paddingRight: '2px' }}>
                                            <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }} textAlign='right' style={{ fontWeight: 'bold' }}> $ {viewBillingAssignmentDetailsAry.assign_total_amount}</Typography>

                                        </TableCell>
                                    </TableRow>

                                    {viewBillingAssignmentDetailsAry.assign_partpay_amount !== "" &&
                                        <TableRow sx={{ borderBottom: 2, borderTop: 2, borderColor: '#a2a2a2de' }}  >
                                            <TableCell sx={{ paddingLeft: '2px' }} >
                                                <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }} style={{ fontWeight: 'bold' }}>Modified Bill Amount</Typography>
                                            </TableCell>
                                            <TableCell sx={{ paddingRight: '2px' }}>
                                                <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle1' } }} textAlign='right' style={{ fontWeight: 'bold' }}> $ {viewBillingAssignmentDetailsAry.assign_partpay_amount}</Typography>
                                            </TableCell>
                                        </TableRow>}

                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    {URLThirdSegmentName === "Assignment_Acceptence" && <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                        <Button sx={{ backgroundColor: appThemeColor, color: '#fff', textTransform: 'none', fontWeight: 'bold', '&:hover': { backgroundColor: appThemeColor } }} startIcon={<KeyboardBackspaceOutlinedIcon />} onClick={() => navigate('/Interpreter/Dashboard')} variant='contained'>
                            Back to Dashboard
                        </Button>
                    </Box>}
                </Box>
            </Box>

        </Box >

    )
}

